var initialFilterHtml = document.querySelector('#bc-sf-filter-options-wrapper').innerHTML;

document.addEventListener('keydown', function(e) {
  if (e.key !== 'Enter' && e.key !== ' ') return;
  let target = e.target.closest('.bc-sf-filter-option-item[role="button"]');
  if (!target) return;
  e.preventDefault();
  onInteractWithFilterOptionValue(target);
});

document.addEventListener('click', function(e) {
  if (!e.target.closest('.js-filter-clear-all')) return;
  e.preventDefault();

  let url = document.querySelector('#filter').dataset.collection;
  let prds = document.querySelector('.prds_list');
  let prdsId = prds.id.replace('shopify-section-', '');

  document.querySelector('#bc-sf-filter-options-wrapper').innerHTML = initialFilterHtml;
  document.querySelectorAll('.js-filter-clear-all').forEach(function(b) { b.style.display = 'none'; });

  fetch(url + '?section_id=' + prdsId).then(r => r.text()).then(function(res) {
    let b = document.createElement('div');
    b.innerHTML = res;
    document.querySelector('.products--collection').innerHTML = b.querySelector('.products--collection').innerHTML;
  });
});

function openFilter(obj){
  let filter = document.querySelector('#bc-sf-filter-tree');
  filter.classList.toggle('filter_open');
  obj.classList.toggle('is-active');
}

function onInteractWithFilterOptionValue(obj){
  obj.classList.toggle('selected');
  let par = obj.closest('li');
  let checkbox = par.querySelector('input');
  checkbox.toggleAttribute('checked');
  obj.setAttribute('aria-pressed', checkbox.hasAttribute('checked'));
  let section = obj.closest('.section-collection');
  let sectionId = section.id.replace('shopify-section-','');
  let url = document.querySelector('#filter').dataset.collection;
  let get = url+'?section_id='+sectionId;

  let prds = document.querySelector('.prds_list');
  let prdsId = prds.id.replace('shopify-section-','');
  let prdsGet = url+'?section_id='+prdsId;

  let filterInputs = document.querySelectorAll('#bc-sf-filter-options-wrapper input:checked');
  document.querySelectorAll('.js-filter-clear-all').forEach(function(b) {
    b.style.display = filterInputs.length > 0 ? 'block' : 'none';
  });

  let str = '';
  let checkArr = new Array();
  for (var item of filterInputs) {
    if(item.name == 'filter.v.option.color'){
      if(window.colorGroupingList[item.value] == undefined){
        checkArr.push(item.value);
      }else{
        checkArr.push(window.colorGroupingList[item.value]);
      }
    }
    str += '&'+item.name+'='+item.value;
  }
  checkArr = checkArr.flat();
  get += str;
  prdsGet += str;

  fetch(prdsGet).then(response => response.text()).then(function(res){
    let b = document.createElement('div');
    b.innerHTML = res;
    if(checkArr.length > 0){
      let prds = b.querySelectorAll('.product.js-product');
      for(prd of prds){
        let swatches = prd.querySelectorAll('.js-list-colors span[data-color-name]');
        let hasMatch = Array.from(swatches).some(function(swatch){
          return checkArr.includes(swatch.dataset.colorName);
        });
        if(hasMatch === false){
          prd.outerHTML = '';
        }
      }
    }
    let newf = b.querySelector('.products--collection').innerHTML;
    let f = document.querySelector('.products--collection');
    f.innerHTML = newf;
  });

  fetch(get).then(response => response.text()).then(function(res){
    let b = document.createElement('div');
    b.innerHTML = res;
    let newf = b.querySelector('#bc-sf-filter-options-wrapper').innerHTML;
    let f = document.querySelector('#bc-sf-filter-options-wrapper');
    f.innerHTML = newf;
  });
}
